enum CODE_TYPE_ENUM {
	EMAIL = 'email',
	SMS = 'sms',
}

export default CODE_TYPE_ENUM;
